import { motion } from 'framer-motion';

const fadeUp = {
    initial: { opacity: 0, y: 24 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: '-50px' },
    transition: { duration: 0.6, ease: 'easeOut' },
};

export function OtherSideSection() {
    return (
        <section data-testid="other-side-section" className="bg-white py-24 md:py-32">
            <div className="max-w-3xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUp}>
                    <h2 className="font-montserrat font-bold text-4xl md:text-5xl text-navy-900 mb-8 tracking-tight">
                        What the Business Looks Like When It's Built Right
                    </h2>
                    <div className="space-y-6 text-[#6B7280] text-lg leading-relaxed">
                        <p>
                            Imagine your CRM is clean and current - without you touching it. Your listings are marketed, your clients are followed up with, your inbox is managed. You go on vacation and your business runs. You take a weekend and nothing falls apart.
                        </p>
                        <p>
                            You net more because your overhead is lean and your systems are tight. You work because you want to, not because everything stops if you don't.
                        </p>
                        <p className="text-navy-900 font-montserrat font-bold text-xl">
                            That's not a fantasy. That's what leverage actually looks like when it's set up properly.
                        </p>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
